/* @jsxImportSource react */

import { cn } from '@packages/shared/src/utils/cn/cn';

export const ResponsiveFullBleedBackground = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'absolute top-0 right-[var(--background-bleed)] bottom-0 left-[var(--background-bleed)] -z-10',
      className,
    )}
  />
);
